import { UserCommunication } from '@this+that/models';

import { canArchiveUserCommunication } from '../utils/canArchiveUserCommunication';

export const useHasUnarchivableSelectedItems = (
  communications: UserCommunication[],
  selectedItems: Set<string>,
) => {
  const checkUnarchivableItems = () => {
    const selectedCommunications = communications.filter((comm) =>
      selectedItems.has(comm.messageId),
    );
    return selectedCommunications.some(
      (comm) => !canArchiveUserCommunication(comm),
    );
  };

  const hasUnarchivableItems = checkUnarchivableItems();

  return { hasUnarchivableItems };
};
